/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { StyleSheet } from 'react-native';

import LoadingIndicator from './LoadingIndicator';
import Modal, { ModalProps } from './Modal';
import Button from './Button';
import Form from './Form';
import SubmitButton from './SubmitButton';

type Props = Pick<ModalProps, 'onClose' | 'style' | 'title' | 'children'> & {
  isOpen?: boolean;
  onSubmit: (event?: any) => unknown;
  isLoading: boolean;
  vendorCounter?: number;
};

function ExportModal(props: Props) {
  const {
    isOpen,
    onSubmit,
    onClose,
    isLoading,
    children,
    style,
    ...otherProps
  } = props;

  return (
    <Modal
      isVisible={isOpen ?? true}
      onClose={onClose}
      style={styles.modal}
      {...otherProps}
    >
      <Form onSubmit={onSubmit} style={styles.modalForm}>
        <Modal.Body
          style={[styles.modalBody, isLoading && styles.loadingWrapper]}
        >
          {isLoading ? <LoadingIndicator /> : children}
        </Modal.Body>
        {!isLoading && (
          <Modal.Footer>
            <Button title="Cancel" onPress={onClose} />
            <SubmitButton title="Export" />
          </Modal.Footer>
        )}
      </Form>
    </Modal>
  );
}

let styles = StyleSheet.create({
  modal: {
    width: 640,
  },
  modalBody: {
    flex: 1,
    margin: 0,
    paddingTop: 10,
  },
  loadingWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalForm: {
    flex: 1,
    paddingHorizontal: 0,
  },
});

export default ExportModal;
